export const apiUrl = process.env.REACT_APP_ENVIRONMENT === "prod" ?
  process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_ENVIRONMENT === "qa" ?
    process.env.REACT_APP_API_URL_QA : process.env.REACT_APP_ENVIRONMENT === "dev" ?
      process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_LOCALHOST;
